import ApiClient from "../api/apiClient";

const CERTIFICATES = "/certificates/";
const APPEAL = "/appeals";
const REFUND = "/refund";
const APPLICATIONCERTIFICATES = "/certificates/go-to-dashboard/";

const getCertificateApplicationDetails = (id) => {
  const url = CERTIFICATES + id;
  return ApiClient.get(url);
};

const createAppeal = (data) => {
  const url = APPEAL;
  return ApiClient.post(url, data);
};

const createRefund = (data) => {
  const url = REFUND;
  return ApiClient.post(url, data);
};

const viewCertificates = (id) => {
  const url = APPLICATIONCERTIFICATES + id;
  return ApiClient.get(url);
};

export const certificateStatusService = {
  getCertificateApplicationDetails,
  createAppeal,
  createRefund,
  viewCertificates,
};
